import { t } from "i18next";
import { useCallback } from "react";
import { ContractNotificationDurationType, LeadTimeUnit } from "../../autogen/bff-api";

export const useNotificationLeadTimeConfig = () => {
  const displayNotificationTypeConfig = useCallback(
    (durationType?: ContractNotificationDurationType | LeadTimeUnit, amount?: number): string => {
      if (!durationType || amount === undefined) throw Error("Invalid leadtime config!");
      switch (durationType) {
        case ContractNotificationDurationType.Days:
          return `${amount} ${t("days before")}`;
        case ContractNotificationDurationType.Months:
          return `${amount} ${t("months before")}`;
        case LeadTimeUnit.Days:
          return `${amount} ${t("days before")}`;
        case LeadTimeUnit.Months:
          return `${amount} ${t("months before")}`;
      }
    },
    []
  );

  return displayNotificationTypeConfig;
};
